import { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'

import { useAppConfig } from '../../request/query/app'

class ConfigChecker extends Component {
  render() {
    const { providerDetails = {}, requiredConfig, requiredValue } = this.props
    const partnerConfigs = get(providerDetails, 'config', [])
    if (!!partnerConfigs.find(({
      config_type = {},
      value
    }) => (value === requiredValue && config_type.name === requiredConfig))) {
      return this.props.children
    }
    return null
  }
}

ConfigChecker.propTypes = {
  partnerDetails: PropTypes.object.isRequired,
  requiredConfig: PropTypes.string.isRequired,
  requiredValue: PropTypes.string.isRequired,
  children: PropTypes.node
}

ConfigChecker.defaultProps = {
  partnerDetails: {},
  children: null
}

const Wrapper = ({ providerDetails, ...rest }) => (
  <ConfigChecker providerDetails={providerDetails} {...rest} />
)

export default function WrappedConfigChecker(props) {
  const { providerDetails } = useAppConfig()
  return <Wrapper providerDetails={providerDetails} {...props} />
}
